export const keywordResearch = {
  title: 'Investigación de Palabras Clave',
  subtitle: 'Genera clusters de keywords y valida con datos reales de búsqueda',
  input: {
    title: 'Iniciar Investigación',
    description: 'Ingresa los datos de tu empresa y selecciona tu mercado objetivo',
    companyName: { label: 'Nombre de Empresa / Producto', placeholder: 'ej. HubSpot' },
    productUrl: { label: 'URL del Producto (opcional)', placeholder: 'https://ejemplo.com' },
    companyDescription: {
      label: 'Descripción de la Empresa',
      placeholder: 'Describe qué hace tu empresa/producto, sus principales características y público objetivo...',
      generateButton: 'Generar con IA',
      generating: 'Generando...',
    },
    country: { label: 'País Objetivo', placeholder: 'Seleccionar país' },
    language: { label: 'Idioma', placeholder: 'Seleccionar idioma' },
    startButton: 'Iniciar Investigación',
  },
  steps: {
    rootProduct: {
      name: 'Producto Raíz',
      fullName: 'Identificar Producto Raíz',
      description: 'La IA analiza tu producto para identificar sus categorías de mercado',
      rootProductLabel: 'Producto Raíz',
      categoriesLabel: 'Categorías de Mercado',
      editHint: 'Haz clic en cualquier categoría para editar o eliminar',
      regenerateRootProduct: 'Regenerar producto raíz',
      generateMoreCategories: 'Generar más categorías',
      generating: 'Generando...',
      instructionsPlaceholder: 'Opcional: describe qué cambiar...',
      loadingTitle: 'Analizando tu producto',
      loadingDescription: 'La IA está identificando tu producto principal y sus categorías de mercado. Esto suele demorar alrededor de un minuto.',
    },
    structuralClusters: {
      name: 'Clusters',
      fullName: 'Construir Clusters Estructurales',
      description: 'Mapear la estructura completa del mercado con clusters de keywords A a J',
      clusterLabels: {
        A: 'Producto Raiz',
        B: 'Plataformas / Stacks',
        C: 'Funcionalidades',
        D: 'Dolores',
        E: 'Resultados / JTBD',
        F: 'Verticales / Audiencias',
        G: 'Implementacion / Dev',
        H: 'Conectores',
        J: 'Competidores Directos',
      },
      generateMoreKeywords: 'Generar más keywords',
      generating: 'Generando...',
      instructionsPlaceholder: 'Opcional: describe en qué enfocarse...',
      deleteCluster: 'Eliminar cluster',
      addCluster: 'Agregar cluster',
      newClusterNamePlaceholder: 'Nombre del cluster...',
      loadingTitle: 'Construyendo clusters de mercado',
      loadingDescription: 'Mapeando la estructura completa del mercado con clusters de keywords a partir de tus categorías de producto. Esto suele demorar un par de minutos.',
    },
    mergeSystem: {
      name: 'Merges',
      fullName: 'Definir Sistema de Merges',
      description: 'Generar fórmulas de combinación para short, mid y long tail',
      typeLabels: { short: 'Short Tail', mid: 'Mid Tail', long: 'Long Tail' },
      intentCategoryLabels: {
        purchase: 'Compra',
        comparison: 'Comparación',
        feature: 'Funcionalidad',
        pain: 'Dolor',
        outcome: 'Resultado',
        vertical: 'Vertical',
        implementation: 'Implementación',
        platform: 'Plataforma',
      },
      intentStrengthLabels: { high: 'Alto', medium: 'Medio', low: 'Bajo' },
      funnelStageLabels: { TOFU: 'TOFU', MOFU: 'MOFU', BOFU: 'BOFU' },
      columns: {
        intentCategory: 'Categoría de Intención',
        type: 'Tipo',
        formula: 'Fórmula',
        formulaReadable: 'Fórmula (Legible)',
        description: 'Descripción',
        examples: 'Ejemplos',
        intentStrength: 'Fuerza de Intención',
        funnelStage: 'Etapa del Funnel',
        actions: 'Acciones',
      },
      clearFilters: 'Limpiar filtros',
      generateMore: 'Generar más merges',
      generating: 'Generando...',
      deleteConfirm: 'Eliminar merge',
      instructionsPlaceholder: 'Opcional: describe qué tipo de merges generar...',
      loadingTitle: 'Construyendo tu sistema de merges',
      loadingDescription: 'Analizando clusters de keywords y generando fórmulas de combinación. Esto suele demorar un par de minutos.',
      filtering: 'Filtrando...',
      noResults: 'Ningún merge coincide con los filtros actuales.',
      allFilter: 'Todos',
    },
    keywordCombinations: {
      name: 'Keywords',
      fullName: 'Generar Combinaciones de Keywords',
      description: 'El sistema genera todas las permutaciones de tus clusters y merges',
      totalKeywords: '{{count}} keywords generadas',
      removeHint: 'Haz clic en una keyword para eliminarla de la lista',
      searchPlaceholder: 'Buscar keywords...',
      showMore: 'Mostrar {{remaining}} mas',
      loadingTitle: 'Generando combinaciones de keywords',
      loadingDescription: 'Creando todas las permutaciones posibles a partir de tus clusters y fórmulas de merge. Esto suele demorar un par de minutos.',
    },
    agenticEnrichment: {
      name: 'IA Expandir',
      fullName: 'Expansión de Keywords con IA',
      description: 'Un agente de IA investiga tu mercado y genera miles de keywords adicionales',
      startButton: 'Iniciar Expansión IA',
      stopButton: 'Detener',
      rerun: 'Re-ejecutar Expansión',
      keywordsDiscovered: 'Keywords Descubiertas',
      activityLog: 'Registro de Actividad',
      insights: 'Insights de Investigación',
      researchTimeline: 'Línea de Investigación',
      seedKeywords: 'semillas encontradas',
      batchesProgress: '{{completed}} de {{total}} lotes completados',
      filterDedup: 'Eliminando duplicados',
      filterQuality: 'Filtro de calidad IA',
      completeSummary: 'keywords nuevas agregadas',
      phaseTime: '{{time}}s',
      errorTitle: 'La expansión falló',
      cancelled: 'La expansión fue cancelada.',
      completeTitle: 'Expansión Completada',
      completedMessage: 'La expansión IA agregó {{count}} keywords nuevas.',
      loadingTitle: 'La IA está investigando tu mercado',
      loadingDescription: 'El agente de IA está analizando competidores, tendencias y lenguaje de usuarios para expandir tu lista de keywords.',
    },
    keywordExpansion: {
      name: 'Expandir',
      fullName: 'Expansión de Keywords',
      description: 'Descubrí nuevas keywords desde DataForSEO y expansión con IA',
      startButton: 'Iniciar Expansión',
      stopButton: 'Detener',
      rerun: 'Re-ejecutar Expansión',
      keywordsDiscovered: 'Nuevas Keywords Descubiertas',
      phases: {
        discovery: 'Descubrimiento DataForSEO',
        aiExpansion: 'Expansión IA',
        volumeEnrichment: 'Enriquecimiento de Volumen',
      },
      batches: {
        site: 'Keywords del Sitio',
        keywords: 'Sugerencias de Keywords',
        ai: 'Expansión IA',
      },
      stats: {
        fromSite: 'del escaneo del sitio',
        fromKeywords: 'de sugerencias de keywords',
        fromAI: 'de expansión IA',
      },
      completeSummary: 'nuevas keywords descubiertas',
      phaseTime: '{{time}}s',
      errorTitle: 'La expansión falló',
      cancelled: 'La expansión fue cancelada.',
      completeTitle: 'Expansión Completada',
      completedMessage: 'La expansión de keywords descubrió {{count}} nuevas keywords.',
    },
    enrichment: {
      name: 'Enriquecimiento',
      fullName: 'Enriquecimiento de Volumen de Búsqueda',
      description: 'Enriquece tus keywords con datos reales de volumen de búsqueda y revisa las etiquetas de intención',
      searchVolume: 'Volumen de Búsqueda',
      competition: 'Competencia',
      cpc: 'CPC',
      keyword: 'Keyword',
      actions: 'Acciones',
      intentCategory: 'Intención',
      intentStrength: 'Fuerza',
      funnelStage: 'Funnel',
      noData: '—',
      noTrendData: 'No hay datos de tendencia para esta keyword',
      loadingTrend: 'Cargando datos de tendencia...',
      trendError: 'No se pudieron cargar los datos de tendencia',
      avgMonthly: 'Prom: {{value}}/mes',
      fetchingVolumes: 'Obteniendo volúmenes de búsqueda...',
      volumeError: 'No se pudieron obtener los volúmenes de búsqueda',
      retryButton: 'Reintentar',
      filterPlaceholder: 'Filtrar keywords...',
      exportCsv: 'Descargar CSV',
      costWarning: 'Cada actualización usa un crédito de API. Evitá actualizar frecuentemente.',
      refreshVolumes: 'Actualizar',
      staleWarning: 'Las keywords cambiaron desde la última consulta de volumen',
      loadingTitle: 'Enriqueciendo keywords',
      loadingDescription: 'Obteniendo volumen de búsqueda y datos de competencia de Google. Esto suele demorar un par de minutos.',
    },
    validation: {
      name: 'Validar',
      fullName: 'Validar con Datos Reales',
      description:
        'Obtener volumen de búsqueda real y datos de competencia de Google Keyword Planner',
      fetchingProgress: 'Obteniendo datos para {{count}} keywords...',
      showMore: 'Mostrar {{remaining}} más',
      downloadCsv: 'Descargar CSV',
      searchPlaceholder: 'Buscar keywords validadas...',
      loadingTitle: 'Validando con Google',
      loadingDescription: 'Obteniendo volumen de búsqueda real y datos de competencia de Google Keyword Planner. Esto suele demorar un par de minutos.',
      columns: {
        keyword: 'Keyword',
        search_volume: 'Volumen de Búsqueda',
        competition: 'Competencia',
        competition_index: 'Índice de Competencia',
        cpc: 'CPC',
        low_top_of_page_bid: 'Puja Baja',
        high_top_of_page_bid: 'Puja Alta',
        funnelStage: 'Etapa del Funnel',
        monetizable: 'Monetizable',
      },
    },
  },
  navigation: {
    previous: 'Anterior',
    next: 'Siguiente',
    regenerate: 'Re-generar',
    skip: 'Omitir',
  },
  completion: {
    title: '¡Investigación Completa!',
    subtitle: 'Tu investigación de keywords está lista para descargar',
    downloadButton: 'Descargar CSV',
    startNew: 'Nueva Investigación',
  },
  loading: {
    analyzingProduct: 'Analizando producto...',
    buildingClusters: 'Construyendo clusters de mercado...',
    definingMerges: 'Definiendo sistema de merges...',
    generatingKeywords: 'Generando combinaciones de keywords...',
    validatingKeywords: 'Validando keywords con Google...',
    exportingCsv: 'Generando CSV...',
  },
  errors: {
    rootProductFailed: 'Error al analizar producto: {{message}}',
    clustersFailed: 'Error al construir clusters: {{message}}',
    mergeFailed: 'Error al definir merges: {{message}}',
    combinationsFailed: 'Error al generar combinaciones: {{message}}',
    validationFailed: 'Error al validar keywords: {{message}}',
    exportFailed: 'Error al exportar CSV: {{message}}',
    retryButton: 'Reintentar',
    manualInput: 'Ingresar manualmente',
  },
  agenticKeyword: {
    title: 'Expansión IA de Keywords',
    subtitle: 'Dejá que la IA investigue tu mercado y descubra miles de keywords',
    steps: {
      input: 'Info Empresa',
      expansion: 'Expansión IA',
      results: 'Resultados y Exportar',
    },
    analyzingProduct: 'Analizando tu producto...',
    analyzingDescription: 'La IA está identificando tu producto principal y categorías de mercado.',
    analyzeError: 'Error al analizar producto',
  },
  list: {
    title: 'Investigaciones de Palabras Clave',
    subtitle: 'Administra tus resultados de investigación de keywords guardados',
    searchPlaceholder: 'Buscar por nombre...',
    newResearch: 'Nueva Investigación',
    standardAlgorithm: 'Algoritmo Estándar',
    aiExpansion: 'Expansión IA',
    emptyTitle: 'No hay investigaciones de keywords aún',
    emptyDescription: 'Iniciá una nueva investigación de keywords para descubrir y guardar keywords para tu estrategia de contenido.',
    deleteTitle: 'Eliminar Investigación de Keywords',
    deleteDescription: '¿Estás seguro de que querés eliminar "{{name}}"? Esto eliminará todas las keywords asociadas. Esta acción no se puede deshacer.',
    columns: {
      name: 'Nombre',
      description: 'Descripción',
      country: 'País',
      language: 'Idioma',
      status: 'Estado',
      keywords: 'Keywords',
      created: 'Creado',
    },
    paginationResults: '{{count}} resultados',
    cancel: 'Cancelar',
    deleteSuccess: 'Investigación de keywords eliminada',
    deleteError: 'Error al eliminar la investigación de keywords',
  },
  detail: {
    backToList: 'Volver a Investigaciones de Keywords',
    exportCsv: 'Exportar CSV',
    linkedinEnrich: 'Enriquecer con LinkedIn',
    expandKeywords: 'Expandir Keywords',
    searchPlaceholder: 'Buscar keywords...',
    editName: 'Editar nombre',
    notFound: 'Investigación de palabras clave no encontrada',
    saveName: 'Guardar',
    cancelEdit: 'Cancelar',
    updateNameError: 'Error al actualizar el nombre',
    keywordsLoadError: 'Error al cargar las keywords',
    retryLoad: 'Reintentar',
    noKeywords: 'Sin keywords aún',
    noKeywordsDescription: 'Guardá keywords desde un asistente de investigación para verlas aquí.',
    columns: {
      keyword: 'Keyword',
      searchVolume: 'Volumen de Búsqueda',
      competition: 'Competencia',
      competitionIndex: 'Índice de Competencia',
      cpc: 'CPC',
      lowBid: 'Puja Baja',
      highBid: 'Puja Alta',
      linkedinPosts: 'Posts LI',
      intentCategory: 'Intención',
      intentStrength: 'Fuerza',
      funnelStage: 'Funnel',
      source: 'Fuente',
    },
    filters: {
      minSearchVolume: 'Volumen Mín.',
      maxCpc: 'CPC Máx.',
      intentCategory: 'Categoría de Intención',
      intentStrength: 'Fuerza de Intención',
      funnelStage: 'Etapa del Funnel',
      all: 'Todos',
      clearFilters: 'Limpiar filtros',
      hasLinkedinPosts: 'Posts de LinkedIn',
      withLinkedinPosts: 'Con posts vinculados',
      source: 'Fuente',
    },
    sourceLabels: {
      googleTrends: 'Trends',
    },
    linkedinPopover: {
      title: 'Posts Vinculados ({{count}})',
      noPostsFound: 'No se encontraron posts',
    },
    selectAll: 'Seleccionar todas las keywords',
    selectKeyword: 'Seleccionar keyword',
    selectedCount: '{{count}} keywords seleccionadas',
    planContents: 'Planear contenidos',
    clearSelection: 'Limpiar selección',
    loadingMore: 'Cargando más...',
    keywordCountProgress: '{{loaded}} / {{total}} keywords',
    allLoaded: '(todo cargado)',
    paginationInfo: '{{from}}-{{to}} de {{total}} keywords',
    expandDialog: {
      title: 'Expandir Keywords',
      description: 'Descubrí nuevas keywords escaneando tu sitio, generando sugerencias y usando expansión con IA.',
      productUrlLabel: 'URL del Producto',
      productUrlPlaceholder: 'https://ejemplo.com',
      rootProductLabel: 'Producto Raíz (opcional)',
      rootProductPlaceholder: 'ej. Software CRM',
      companyDescriptionLabel: 'Descripción de la Empresa (opcional)',
      companyDescriptionPlaceholder: 'Describí qué hace tu empresa/producto...',
      startButton: 'Iniciar Expansión',
    },
    expandPanel: {
      dismiss: 'Descartar',
      restart: 'Reiniciar Expansión',
      expansionFailed: 'La expansión falló',
    },
  },
  save: {
    buttonLabel: 'Guardar Keywords',
    dialogTitle: 'Guardar Keywords',
    dialogDescription: 'Guardar {{count}} keywords en una investigación.',
    createNew: 'Crear Nueva',
    addToExisting: 'Agregar a Existente',
    nameLabel: 'Nombre',
    namePlaceholder: 'ej. Keywords SEO Q1 2026',
    descriptionLabel: 'Descripción (opcional)',
    descriptionPlaceholder: 'Breve descripción de esta investigación...',
    countryLabel: 'País',
    languageLabel: 'Idioma',
    selectResearch: 'Seleccionar investigación',
    noExistingResearches: 'No se encontraron investigaciones existentes',
    saving: 'Guardando...',
    saveButton: 'Guardar',
    successMessage: 'Keywords guardadas exitosamente',
    errorMessage: 'Error al guardar las keywords',
  },
  creation: {
    title: 'Nueva Investigación de Keywords',
    subtitle: 'Configurá tu investigación y nuestro agente de IA se encargará del resto',
    modes: {
      ai: 'Generar con IA',
      import: 'Importar CSV',
    },
    fields: {
      name: { label: 'Nombre de la Investigación', placeholder: 'ej. Keywords SEO Q1 2026' },
      companyName: { label: 'Nombre de Empresa / Producto', placeholder: 'ej. HubSpot' },
      productUrl: {
        label: 'URL del Producto',
        placeholder: 'https://ejemplo.com',
        hint: 'Incluí el dominio completo (ej. https://tusitio.com)',
      },
      companyDescription: {
        label: 'Descripción de la Empresa',
        placeholder: 'Describí qué hace tu empresa/producto, sus principales características y público objetivo...',
      },
      country: { label: 'País Objetivo', placeholder: 'Seleccionar país' },
      language: { label: 'Idioma', placeholder: 'Seleccionar idioma' },
    },
    description: {
      badge: 'Lo Más Importante',
      helper: 'Esta descripción guía toda la investigación del agente de IA. Cuanto más detallada y precisa, mejores serán los resultados.',
      generateButton: 'Generar con IA',
      generating: 'Generando...',
      aiWarning: 'Las descripciones generadas por IA pueden no reflejar completamente tu producto. Revisá y editá antes de enviar.',
    },
    asyncBanner: 'Proceso en segundo plano — tiempo estimado ~30 minutos',
    submit: {
      button: 'Iniciar Investigación',
      submitting: 'Iniciando...',
    },
    validation: {
      toastTitle: 'Revisá los datos del formulario',
      toastFallback: 'Algunos campos requieren tu atención.',
      nameRequired: 'Asigná un nombre a la investigación.',
      companyNameRequired: 'Ingresá el nombre de tu empresa o producto.',
      productUrlRequired: 'Ingresá la URL de tu producto.',
      productUrlInvalid: 'La URL no es válida. Usá el formato https://tusitio.com',
      countryRequired: 'Elegí un país objetivo.',
      languageRequired: 'Elegí un idioma.',
      submitFailed: 'No pudimos iniciar la investigación',
      generateDescriptionFailed: 'No pudimos generar la descripción',
    },
    confirmation: {
      title: '¡Investigación Iniciada!',
      subtitle: 'Tu investigación se está ejecutando en segundo plano',
      summary: {
        name: 'Nombre',
        company: 'Empresa',
        url: 'URL',
        country: 'País',
        language: 'Idioma',
      },
      estimatedTime: 'Tiempo estimado: ~30 minutos',
      trackProgress: 'Podés seguir el progreso en tu lista de investigaciones',
      goToList: 'Ir a Mis Investigaciones',
      startAnother: 'Iniciar Otra Investigación',
    },
    import: {
      title: 'Importar Investigación de Keywords desde CSV',
      subtitle: 'Subí un CSV, mapeá sus columnas y guardá las keywords directamente en una investigación',
      descriptionLabel: 'Descripción (opcional)',
      descriptionPlaceholder: 'Nota breve sobre este dataset importado...',
      uploadTitle: 'Carga de CSV',
      uploadHint: 'Subí el CSV que querés importar. Detectaremos los encabezados y te dejaremos mapear cada columna.',
      previewLoading: 'Leyendo el CSV y preparando la vista previa...',
      previewError: 'No se pudo generar la vista previa del CSV',
      fileSummary: '{{name}} cargado con {{rows}} filas y {{columns}} columnas',
      mappingTitle: 'Mapeo de Columnas',
      mappingHint: 'Elegí qué columna del CSV debe poblar cada campo. Solo la columna de keyword es obligatoria.',
      selectColumn: 'Seleccionar columna del CSV',
      unmapped: 'No importar',
      required: '(obligatorio)',
      previewTitle: 'Vista Previa del CSV',
      previewHint: 'Mostrando las primeras filas tal como fueron parseadas desde el archivo.',
      reparse: 'Actualizar Vista Previa',
      reset: 'Reiniciar',
      submit: 'Importar Investigación',
      submitting: 'Importando...',
      submitError: 'Error al importar el CSV',
      success: '{{count}} keywords importadas ({{skipped}} omitidas)',
      dropzoneTitle: 'Arrastrá y soltá tu CSV aquí',
      dropzoneOr: 'o',
      autoMapped: 'Auto',
      conflictBadge: 'Conflicto',
      conflictWithMessage: 'Esta columna ya está asignada a "{{field}}". Elegí otra columna o quitala del otro campo.',
      duplicateMappingBannerTitle: 'Hay columnas asignadas a más de un campo',
      duplicateMappingBannerHint: 'Cada columna del CSV solo puede mapear a un campo. Resolvé los conflictos antes de importar.',
      usedBy: 'usada por {{field}}',
      rows: '{{count}} filas',
      columns: '{{count}} cols',
      fields: {
        keyword: 'Keyword',
        search_volume: 'Volumen de Búsqueda',
        competition: 'Competencia',
        competition_index: 'Índice de Competencia',
        cpc: 'CPC',
        low_top_of_page_bid: 'Puja Baja de Parte Superior',
        high_top_of_page_bid: 'Puja Alta de Parte Superior',
        intent_category: 'Categoría de Intención',
        intent_strength: 'Fuerza de Intención',
        funnel_stage: 'Etapa del Funnel',
      },
    },
  },
  toast: { exportSuccess: 'CSV descargado exitosamente' },
  countries: {
    GLOBAL: 'Global',
    US: 'Estados Unidos',
    ES: 'España',
    AR: 'Argentina',
    MX: 'México',
    CO: 'Colombia',
    CL: 'Chile',
    PE: 'Perú',
    GT: 'Guatemala',
    BR: 'Brasil',
    GB: 'Reino Unido',
    DE: 'Alemania',
    FR: 'Francia',
  },
  languages: { en: 'Inglés', es: 'Español', pt: 'Portugués', fr: 'Francés', de: 'Alemán' },
  asyncPipeline: {
    runInBackground: 'Ejecutar en segundo plano',
    researchName: 'Nombre de la Investigación',
    researchNamePlaceholder: 'ej. Keywords SEO Q1 2026',
    startAsync: 'Iniciar Investigación en Segundo Plano',
    asyncStarted: '¡Investigación en segundo plano iniciada! Podés cerrar esta página.',
    asyncStartError: 'Error al iniciar la investigación en segundo plano',
    stepNames: {
      root_product: 'Analizando Producto',
      structural_clusters: 'Construyendo Clusters',
      merge_system: 'Creando Merges',
      keyword_combinations: 'Generando Keywords',
      agentic_enrichment: 'Expansión IA',
      search_volume: 'Obteniendo Volúmenes',
      keyword_expansion: 'Expandiendo Keywords',
      saving_keywords: 'Guardando Keywords',
    },
    jobStatus: {
      pending: 'Pendiente',
      running: 'Ejecutando',
      completed: 'Completado',
      failed: 'Fallido',
    },
  },
  collections: {
    selectFolder: 'Seleccionar todas las keywords de {{name}}',
    ungroupedFolder: 'Sin asignar',
    newFolder: 'Nueva carpeta',
    nameLabel: 'Nombre de la carpeta',
    namePlaceholder: 'ej. Campaña de invierno',
    createTitle: 'Nueva carpeta',
    createEmpty: 'Creá una carpeta vacía. Podés agregarle keywords después.',
    createWithSelection: 'Se agregará {{count}} keyword seleccionada a la nueva carpeta.',
    createWithSelection_one: 'Se agregará {{count}} keyword seleccionada a la nueva carpeta.',
    createWithSelection_other: 'Se agregarán {{count}} keywords seleccionadas a la nueva carpeta.',
    createConfirm: 'Crear carpeta',
    addToFolder: 'Agregar a carpeta',
    addToFolderMenuTitle: 'Agregar a una carpeta existente',
    moveToFolder: 'Mover a carpeta',
    moveToFolderMenuTitle: 'Mover a una carpeta (la saca de las demás)',
    noFolders: 'Todavía no hay carpetas',
    loadingFolders: 'Cargando carpetas…',
    folderMenu: 'Opciones de la carpeta {{name}}',
    rename: 'Renombrar',
    delete: 'Eliminar',
    renameTitle: 'Renombrar carpeta',
    renameConfirm: 'Guardar',
    renamed: 'Carpeta renombrada',
    deleteTitle: 'Eliminar carpeta',
    deleteConfirmBody:
      '¿Eliminar "{{name}}"? Sus keywords siguen en tu research y en cualquier otra carpeta a la que pertenezcan.',
    removeFromFolder: 'Quitar de carpeta',
    removeFromFolderMenuTitle: 'Quitar la selección de una carpeta',
    keywordsRemoved: '{{count}} keyword quitada de la carpeta',
    keywordsRemoved_one: '{{count}} keyword quitada de la carpeta',
    keywordsRemoved_other: '{{count}} keywords quitadas de la carpeta',
    keywordsMoved: '{{count}} keyword movida',
    keywordsMoved_one: '{{count}} keyword movida',
    keywordsMoved_other: '{{count}} keywords movidas',
  },
  selection: {
    keywordCount_one: '{{count}} keyword',
    keywordCount_other: '{{count}} keywords',
    keywordCount: '{{count}} keywords',
    collectionCreated: 'Carpeta creada',
    collectionDeleted: 'Carpeta eliminada',
    keywordsAdded: '{{count}} keywords agregadas',
    keywordsAdded_one: '{{count}} keyword agregada',
    keywordsAdded_other: '{{count}} keywords agregadas',
    totalVolume: 'Vol: {{value}}',
    avgCpc: 'CPC: {{value}}',
    bucketTransactional: '{{count}} transaccionales',
    bucketInformational: '{{count}} informacionales',
    addManualButton: 'Agregar keyword',
    addManualTitle: 'Agregar keyword manual',
    addManualDescription: 'Agregá una keyword sola. Volume y CPC se enriquecen en segundo plano si no llegan al instante.',
    addManualConfirm: 'Agregar',
    keywordLabel: 'Keyword',
    keywordPlaceholder: 'mejor crm para ecommerce',
    intentCategoryLabel: 'Intent',
    intentStrengthLabel: 'Fuerza',
    funnelStageLabel: 'Embudo',
    manualAddedEnriched: 'Keyword agregada y enriquecida',
    manualAddedQueued: 'Keyword agregada, enriquecimiento encolado',
    errorGeneric: 'Algo salió mal',
    positioning: {
      button: 'Agregar a lista',
      menuTitle: 'Agregar a una lista de posicionamiento',
      createNew: 'Crear nueva lista…',
      noLists: 'Todavía no hay listas',
      loading: 'Cargando listas…',
      added: '{{count}} keywords agregadas',
      added_one: '{{count}} keyword agregada',
      added_other: '{{count}} keywords agregadas',
      addedWithSkipped: '{{added}} agregadas, {{skipped}} ya existían',
      createdAndAdded: 'Lista creada · {{count}} keywords agregadas',
      createdAndAdded_one: 'Lista creada · {{count}} keyword agregada',
      createdAndAdded_other: 'Lista creada · {{count}} keywords agregadas',
      createdAndAddedWithSkipped: 'Lista creada · {{added}} agregadas, {{skipped}} ya existían',
      error: 'No se pudieron agregar las keywords a la lista',
    },
  },
} as const
